"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Button = exports.PrimaryButton = exports.BaseButton = exports.WrapperButtons = exports.OptionsTooltipTriangle = exports.OptionAction = exports.OptionsTooltip = exports.OptionsTitle = exports.WrapperOptions = exports.Wrapper = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Wrapper = _styledComponents["default"].div.withConfig({
  displayName: "ShipmentActionsStyles__Wrapper",
  componentId: "xlq5qn-0"
})(["display:flex;flex-direction:row;justify-content:space-between;padding:1.6rem 1.2rem;"]);

exports.Wrapper = Wrapper;

var WrapperOptions = _styledComponents["default"].div.withConfig({
  displayName: "ShipmentActionsStyles__WrapperOptions",
  componentId: "xlq5qn-1"
})(["display:flex;flex-direction:row;justify-content:flex-start;align-items:center;width:30%;position:relative;"]);

exports.WrapperOptions = WrapperOptions;

var OptionsTitle = _styledComponents["default"].span.withConfig({
  displayName: "ShipmentActionsStyles__OptionsTitle",
  componentId: "xlq5qn-2"
})(["font-size:1rem;color:#489ce9;font-weight:bold;cursor:default;padding:1rem 0;"]);

exports.OptionsTitle = OptionsTitle;

var OptionsTooltip = _styledComponents["default"].div.withConfig({
  displayName: "ShipmentActionsStyles__OptionsTooltip",
  componentId: "xlq5qn-3"
})(["background:white;border-radius:0.4rem;position:absolute;bottom:2rem;right:3.5rem;color:black;box-shadow:0 10px 20px rgba(0,0,0,0.19),0 6px 6px rgba(0,0,0,0.23);transition:all 0.3s cubic-bezier(0.25,0.8,0.25,1);width:12rem;padding:0rem 1rem;display:flex;flex-direction:column;align-items:flex-end;cursor:pointer;"]);

exports.OptionsTooltip = OptionsTooltip;

var OptionAction = _styledComponents["default"].div.withConfig({
  displayName: "ShipmentActionsStyles__OptionAction",
  componentId: "xlq5qn-4"
})(["font-size:1rem;font-weight:normal;padding:0.6rem 0.1rem;width:calc(100% + 29px);text-align:end;margin-right:-16px;&:hover{background-color:#489ce966}"]);

exports.OptionAction = OptionAction;

var OptionsTooltipTriangle = _styledComponents["default"].div.withConfig({
  displayName: "ShipmentActionsStyles__OptionsTooltipTriangle",
  componentId: "xlq5qn-5"
})(["width:0;height:0;border-left:0.8rem solid transparent;border-right:0.8rem solid transparent;border-bottom:0.8rem solid rgba(255,255,255,0.9);font-size:0;line-height:0;position:absolute;top:-0.2rem;right:0;"]);

exports.OptionsTooltipTriangle = OptionsTooltipTriangle;

var WrapperButtons = _styledComponents["default"].div.withConfig({
  displayName: "ShipmentActionsStyles__WrapperButtons",
  componentId: "xlq5qn-6"
})(["display:flex;flex-direction:row;justify-content:flex-end;align-items:center;width:70%;text-align:center;"]);

exports.WrapperButtons = WrapperButtons;

var BaseButton = _styledComponents["default"].div.withConfig({
  displayName: "ShipmentActionsStyles__BaseButton",
  componentId: "xlq5qn-7"
})(["font-size:1rem;color:white;cursor:pointer;border-radius:0.4rem;display:flex;flex-direction:row;justify-content:center;align-items:center;height:40px;width:160px;font-weight:bold;box-shadow:0 1px 2px 0 rgba(8,236,186,0.28);"]);

exports.BaseButton = BaseButton;
var PrimaryButton = (0, _styledComponents["default"])(BaseButton).withConfig({
  displayName: "ShipmentActionsStyles__PrimaryButton",
  componentId: "xlq5qn-8"
})(["background:linear-gradient(139.24deg,#2f4ff1 0%,#4184f9 100%);"]);
exports.PrimaryButton = PrimaryButton;
var Button = (0, _styledComponents["default"])(BaseButton).withConfig({
  displayName: "ShipmentActionsStyles__Button",
  componentId: "xlq5qn-9"
})(["font-weight:bold;background:", ";border:", ";color:", ";"], function (props) {
  return props.type === 'outline' ? 'white' : 'linear-gradient(139.24deg, #2f4ff1 0%, #4184f9 100%)';
}, function (props) {
  return props.type === 'outline' ? '2px #5B8CF7 solid' : 'initial';
}, function (props) {
  return props.type === 'outline' ? '#5B8CF7' : 'white';
});
exports.Button = Button;